import Vue from 'vue';
import Vuex from 'vuex';
import map from './modules/map/';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
  modules: {
    map
  },
  strict: debug
});

export default store;